import SentryHook from "@utils/SentryHook.js";
import RootStore from './store/RootStore.svelte';
import ShopProduct from './store/ShopProduct.svelte';
import SubscriptionPurchaseOnboarding from './store/SubscriptionPurchaseOnboarding.svelte';
import FullAdoptionSubscription from './store/tfc/FullAdoptionSubscription.svelte';
import RenewalSubscription from './store/tfc/RenewalSubscription.svelte';
import component from "svelte-tag";
import {MarketingSDK} from "./utils/MarketingSDK";

window.Marketing = new MarketingSDK();

new component({component:RootStore,tagname:"oto-shop",attributes:["organziation"]})
new component({component:ShopProduct,tagname:"oto-shop-product",attributes:["organziation","product"]})
new component({component:SubscriptionPurchaseOnboarding,tagname:"oto-subscription-onboarding",attributes:["organziation","product", "matchkey"]})
new component({component:FullAdoptionSubscription,tagname:"oto-full-adoption",attributes:["product", "matchkey", "organization", "location", "user", "study", "studyEnrollmentToken"]})
new component({component:RenewalSubscription,tagname:"oto-renewal",attributes:["product", "organization", "location", "user"]})